import { BarChart3 } from "lucide-react";

export default function PlaceholderView({
  title,
  description,
  emptyTitle = "Belum tersedia",
  emptyText,
  icon: Icon = BarChart3,
}) {
  return (
    <div>
      <h1 className="font-display text-3xl font-semibold text-[#0B2440] md:text-4xl">
        {title}
      </h1>
      <p className="mt-3 max-w-2xl text-sm leading-relaxed text-slate-500">
        {description}
      </p>

      <div
        data-testid="placeholder-empty"
        className="mt-10 flex flex-col items-center rounded-3xl border border-dashed border-[#D8E2EC] bg-white px-6 py-16 text-center"
      >
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#EFF6FC] text-[#1479BF]">
          <Icon aria-hidden="true" className="h-7 w-7" />
        </span>
        <p className="mt-5 font-display text-lg font-semibold text-[#0B2440]">
          {emptyTitle}
        </p>
        <p className="mt-2 max-w-sm text-xs leading-relaxed text-slate-400">
          {emptyText}
        </p>
      </div>
    </div>
  );
}
